const $ = require('jquery');
const EmailValidator = require('../../utilities/EmailValidator');

module.exports = class DemoEmailPrefill {
	constructor() {
		const emailValidator = new EmailValidator();
		let initOnChange = true;

		$('[data-component="demo-form-prefill-trigger"]').on('click', e => {
			e.preventDefault();
			const idSelector = $(e.currentTarget).data('emailinputselector');
			const $emailInput = $(idSelector);

			if (initOnChange) {
				const handler = () => {
					if (emailValidator.isValid($emailInput.val(), true)) {
						$(`${idSelector}-parent`).removeClass('is-error');
					}
				};
				$emailInput.on('keyup', handler);
				$emailInput.on('change', handler);

				initOnChange = false;
			}

			const email = $emailInput.val();

			if (!emailValidator.isValid(email, true)) {
				$(`${idSelector}-parent`).addClass('is-error');
				return;
			}

			const $email = $('[data-formtype="demo"]').find('[name="Email"]');
			$email.val(email);
			$email.change();
			$email.blur();

			$(`${idSelector}-sidebar-open`).click();

			$email.focus();
		});
	}
}
